import { Button, Container, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

import styles from "./NotFoundPage.module.css";

export const NotFoundPage = () => {
    // Hooks
    const { pathname } = useLocation();

    return (
        <Container className={styles.page}>
            <Typography variant="h3" component="h1" gutterBottom>
                Page not found
            </Typography>
            <Typography color="text.secondary">There is nothing at {pathname}.</Typography>
            <div className={styles.actions}>
                <Button component={Link} to="/" variant="contained">
                    Go home
                </Button>
            </div>
        </Container>
    );
};
